import { NavMarker } from 'react-rhumb';
import enviro from 'enviro';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flow } from 'signup-constants/Flow';
import ViralLink from 'viral-links-lib/viral-link/ViralLink';
import { getLiveChatParams } from '../utils/urls';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LiveChatIntermediate() {
  const queryParams = getLiveChatParams();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "LIVE_CHAT_LINK_LOADED",
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      children: /*#__PURE__*/_jsx(ViralLink, {
        use: "primary",
        portalId: queryParams.viralSourcePortalId ? parseInt(queryParams.viralSourcePortalId, 10) : undefined,
        environment: enviro.getShort(),
        flow: Flow.Crm,
        viralLinkType: "livechat-intermediate",
        additionalParams: queryParams
        /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */,
        intermediatePage: "https://local.hubspotqa.com/promo/",
        ariaLabel: I18n.text('app.viralLinks.liveChatIntermediate.ariaLabel'),
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "app.viralLinks.liveChatIntermediate.linkCta"
        })
      })
    })
  });
}